import setFilters from 'store/reducer-utils/setFilters'
import {
  // LINKS_FILTERS_APPLY,
  LINKS_RESET_DATA,
  LINKS_SET_DATA,
  LINKS_SET_FILTERS,
} from 'modules/Referral/ReferralLinks/types'

const initialState = {
  data: null,
  pagination: {
    limit: 20,
    offset: 0,
  },
  filters: null,
}

const setReferralLinkFilters = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(
    { ...state, data: [], pagination: initialState.pagination },
    { ...action, payload: filteredPayload },
  )
}

/*const applyReferralLinkFilters = (state, { payload }) => ({
  ...state,
  filters: payload,
})*/

const setReferralLinksData = (state, { payload }) => ({
  ...state,
  ...payload,
})

const resetReferralLinksData = () => ({
  ...initialState,
})

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LINKS_RESET_DATA:
      return resetReferralLinksData(state, action)
    case LINKS_SET_FILTERS:
      return setReferralLinkFilters(state, action)
    /*case LINKS_FILTERS_APPLY:
      return applyReferralLinkFilters(state, action)*/
    case LINKS_SET_DATA:
      return setReferralLinksData(state, action)

    default:
      return state
  }
}

export default reducer
